import React from 'react';
import { motion } from 'framer-motion';
const pains = [{
  emoji: '😰',
  title: 'Agotamiento Mental',
  desc: 'Pasás el día resolviendo crisis, anticipando berrinches y tratando de evitar explosiones sin tener un plan claro.'
}, {
  emoji: '🌪️',
  title: 'Caos en Rutinas',
  desc: 'Vestirse, salir, apagar pantallas o dormir se convierten en luchas diarias que terminan agotándote a vos también.'
}, {
  emoji: '📱',
  title: 'Demasiada Información, Poca Aplicación',
  desc: 'Leíste consejos, viste videos y probaste ideas sueltas, pero nada te da una estructura simple para usar hoy en tu casa.'
}, {
  emoji: '😩',
  title: 'Carga Emocional Constante',
  desc: 'Sentís culpa, cansancio y frustración porque querés hacerlo mejor, pero muchas veces reaccionás desde el agotamiento.'
}];
export function PainPoints() {
  return <section className="py-20 bg-white" data-id="element-173">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-174">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-175">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-176">
            ¿Te reconoces en esto?
          </h2>
          <p className="text-lg text-gray-600" data-id="element-177">
            Querés ayudar a tu hijo, pero sentís que el día a día te supera más
            de lo que te gustaría.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8" data-id="element-178">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-ocean-cream p-8 rounded-3xl border border-gray-100 shadow-sm hover:shadow-soft transition-shadow" data-id="element-179">
              <div className="text-4xl mb-4" aria-hidden="true" data-id="element-180">
                {pain.emoji}
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-900" data-id="element-181">
                {pain.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-182">{pain.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}